import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {  trigger,
  state,
  style,
  animate,
  transition
} from "@angular/animations";
import {addStylesToBlock} from '../../helpers';

enum MOBILE_BLOCKS {
  date,
  time,
  timezone,
  reviewInfo,
  editInfo,
  allSet,
  cancel
}

@Component({
  selector: 'app-mobile-calendar',
  templateUrl: './mobile-calendar.component.html',
  styleUrls: ['./mobile-calendar.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        style({transform: 'translateX(-100%)'}),
        animate("0.2s ease-in-out")
      ]),
      transition('* => void', [
        animate("0.2s ease-in-out", style({transform: 'translateX(100%)'}))
      ])
    ]),
    trigger('flyBottomTop', [
      state('in', style({transform: 'translateY(0)'})),
      transition('void => *', [
        style({transform: 'translateY(100%)'}),
        animate("0.2s ease-in-out")
      ]),
      transition('* => void', [
        animate("0.2s ease-in-out", style({transform: 'translateY(100%)'}))
      ])
    ])
  ]
})
export class MobileCalendarComponent implements OnInit {

  @Output() newPage = new EventEmitter();

  title = 'app';
  selectedDate  = null;


  MOBILE_BLOCKS = MOBILE_BLOCKS;
  activeBlock: MOBILE_BLOCKS = MOBILE_BLOCKS.date;

  reviewInfo = null;

  openEditDate() {
    this.activeBlock = MOBILE_BLOCKS.date;
  }
  onDateSelected($event) {
    this.selectedDate = $event;
    this.openEditTime();
  }

  openEditTime() {
    this.activeBlock = MOBILE_BLOCKS.time;
  }
  onTimeSelected($event) {
    this.reviewInfo = $event;
    this.activeBlock = MOBILE_BLOCKS.reviewInfo;
  }

  openTimeZoneFunc() {
    this.activeBlock = MOBILE_BLOCKS.timezone;
  }
  closeTimeZoneFunc() {
    this.activeBlock = MOBILE_BLOCKS.time;
  }


  openEditInfo() {
    this.activeBlock = MOBILE_BLOCKS.editInfo;
  }
  closeEditInfo() {
    this.activeBlock = MOBILE_BLOCKS.reviewInfo;
  }


  openCancelDemo() {
    this.activeBlock = MOBILE_BLOCKS.cancel;
  }
  closeCancelDemo() {
    this.activeBlock = MOBILE_BLOCKS.allSet;
  }


  openYoureAllSet() {
    this.activeBlock = MOBILE_BLOCKS.allSet;
    addStylesToBlock('.popular-sharpspring-content', 'display: block');
  }
  closeYoureAllSet() {
    this.activeBlock = MOBILE_BLOCKS.editInfo;
    addStylesToBlock('.popular-sharpspring-content', '');
  }


  openCalendarFunc() {
    this.activeBlock = MOBILE_BLOCKS.date;
    this.selectedDate = null;
    this.reviewInfo = null;

    addStylesToBlock('.popular-sharpspring-content', '');
    addStylesToBlock('#starter-steps', '');
    addStylesToBlock('.activation-title', '');
  }

  constructor() {}

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /app/src/app/Components/mobile-calendar/mobile-calendar.component.ts